import { Component, Input, Output, EventEmitter, HostBinding } from '@angular/core';
import { NgIf, NgFor, NgClass } from '@angular/common';

export interface GroupedRadioOption {
	value: string;
	label: string;
	enabled?: boolean;
	descriptions?: string[];
}

export interface GroupedRadioOptions {
	id: string;
	groupName: string;
	options: GroupedRadioOption[];
}

@Component({
	selector: 'form-grouped-radio-group',
	standalone: true,
	template: `
		<div class="group">
			<strong>{{ group.groupName }}</strong>
		</div>
		<ul
			[ngClass]="{
				'radioGroup--horizontal': orientation === 'horizontal',
				'radioGroup--textSmall': textSize === 'small',
			}"
			[attr.aria-label]="a11yGroupDescription"
			role="radiogroup"
			*ngIf="group.options"
		>
			<li *ngFor="let option of group.options; let i = index">
				<ng-container>
					<input
						type="radio"
						[name]="sharedControlName"
						[id]="'radio-' + group.groupName + '-' + group.id + '-' + i"
						[disabled]="option.enabled !== true"
						[value]="option.value"
						[checked]="selectedValue === option.value"
						(change)="onSelectionChange(option.value)"
					/>
					<label [for]="'radio-' + group.groupName + '-' + group.id + '-' + i">{{ option.label }}</label>
					<ng-container *ngFor="let description of option.descriptions">
						<p>{{ description }}</p>
					</ng-container>
				</ng-container>
			</li>
		</ul>
	`,
	styleUrls: ['./grouped-radio-group.component.scss'],
	imports: [NgIf, NgFor, NgClass],
})
export class GroupedRadioGroupComponent {
	@Input() a11yGroupDescription: string;
	@Input() group!: GroupedRadioOptions;
	@Input() sharedControlName!: string;
	@Input() selectedValue!: string;
	@Output() selectionChange = new EventEmitter<string>();

	@Input() orientation: 'horizontal' | 'vertical' = 'vertical';
	@Input() textSize: 'small' | 'default' = 'default';
	@Input() style: 'chip' | 'default' = 'default';

	@HostBinding('class')
	get radioGroupStyleClass(): string {
		return this.style;
	}

	onSelectionChange(value: string): void {
		this.selectionChange.emit(value);
	}
}
